import {combineReducers, configureStore} from "@reduxjs/toolkit"
import {useDispatch as useStoreDispatch} from "react-redux"
import auth from "./api/authSlice";
import {branchApi} from "./api/branchApi";
import {cityApi} from "./api/cityApi";
import {geocoderApi} from "./api/geocoderApi";
import {userApi} from "./api/userApi";

// List reducers
export const reducer = combineReducers({
    [branchApi.reducerPath]: branchApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
    [geocoderApi.reducerPath]: geocoderApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    auth
})

export type StoreState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export const useDispatch = () => useStoreDispatch<AppDispatch>()


export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({immutableCheck: false})
            .concat(branchApi.middleware)
            .concat(cityApi.middleware)
            .concat(geocoderApi.middleware)
            .concat(userApi.middleware)
})
